import ReviewsCarousel from './ReviewsCarousel';
import TelStoreCover from './TelStoreCover';
import ReviewAuthor from './ReviewAuthor';
import AccessibleFaqItem from './AccessibleFaqItem';
import LeadForm from './LeadForm';
import CommerceEcosystem from './CommerceEcosystem';
import PageMeta from './PageMeta';
import {
  RedesignFooter,
  RedesignHeader,
  RedesignPage,
  SiteLink,
} from './RedesignShell';

const seoHref = 'https://fatalitystudio.ru/services/websites/seo/';

const ecommerceTasks = [
  'создать канал онлайн-продаж;',
  'увеличить поток клиентов;',
  'автоматизировать обработку заказов;',
  'подключить оплату и доставку;',
  'собрать данные о клиентах;',
  <>запустить рекламу и <SiteLink href={seoHref}>SEO-продвижение</SiteLink></>,
];

const salesTasks = [
  'продавать товары 24/7 без участия менеджера;',
  'обрабатывать заказы автоматически;',
  'подключать платежные системы и онлайн-кассы;',
  'управлять каталогом товаров и остатками;',
  'отслеживать поведение пользователей;',
  'запускать рекламу (Яндекс Директ, соцсети) и получать бесплатные заявки из органики;',
  'собирать аналитику и данные.',
];

const growthTasks = [
  'Быстро выйти на рынок',
  'Протестировать нишу',
  'Увеличить конверсию',
  'Масштабировать продажи',
];

const storeTypes = [
  {
    title: 'Интернет-магазин товаров',
    paragraphs: [
      'Классический интернет-магазин с каталогом и карточками товаров. Подходит для большинства ниш: одежда, техника, мебель, услуги.',
      'Такой сайт включает:',
    ],
    list: ['каталог товаров;', 'категории товаров;', 'карточки с описанием;', 'корзину;', 'личный кабинет.'],
  },
  {
    title: 'Интернет-магазин с каталогом и фильтрами',
    paragraphs: ['Подходит для проектов с большим ассортиментом товаров.', 'Функционал:'],
    list: ['фильтрация по параметрам;', 'сортировка товаров;', 'быстрый поиск;', 'удобная навигация.'],
    after: 'Такой интернет-магазин помогает пользователю быстрее найти нужный товар и оформить заказ.',
  },
  {
    title: 'Интернет-магазин с интеграцией CRM',
    paragraphs: ['Это полноценная система управления продажами.', 'Мы интегрируем интернет-магазин с CRM, чтобы:'],
    list: [
      'автоматически обрабатывать заявки;',
      'сохранять данные клиентов;',
      'управлять статусами заказов;',
      'отслеживать продажи;',
      'строить аналитику.',
    ],
    after: 'Важно! Мы сразу внедряем CRM при разработке. Вам не придется делать это отдельно. Мы создаем НЕ САЙТ — А СИСТЕМУ ПРОДАЖ!',
  },
  {
    title: 'Персонализированные интернет-магазины',
    paragraphs: ['Разработка интернет-магазина с нуля под конкретный бизнес.', 'Подходит для:'],
    list: ['крупных проектов;', 'сложных бизнес-процессов;', 'нестандартных задач.'],
    secondTitle: 'Преимущества:',
    secondList: ['уникальный дизайн;', 'гибкая система;', 'интеграции с 1С, CRM, API;', 'масштабируемость.'],
  },
];

const includedSteps = [
  {
    title: 'Аналитика и проектирование',
    text: 'На первом этапе проводится анализ:',
    list: ['ниши;', 'Seo-факторов;', 'конкурентов;', 'целевой аудитории.'],
    after: 'Формируется структура сайта и прототип. Это основа будущего проекта.',
  },
  {
    title: 'UX/UI дизайн',
    text: 'Создается дизайн интернет-магазина. Учитывается:',
    list: ['удобство использования;', 'логика поведения пользователя;', 'конверсионные элементы.'],
    after: 'Дизайн влияет на продажи. Чем он проще и понятнее — тем выше конверсия из трафика в покупку.',
  },
  {
    title: 'Разработка и программирование',
    text: 'На этом этапе создается функционал интернет-магазина:',
    list: ['каталог товаров;', 'карточка товара;', 'корзина;', 'система заказов;', 'личный кабинет.'],
    after: 'Мы разрабатываем интернет-магазины на любой CMS или с нуля на «чистом коде».',
  },
  {
    title: 'SEO-оптимизация интернет-магазина',
    text: <><SiteLink href={seoHref}>SEO</SiteLink> — важный этап разработки.</>,
    listTitle: 'Настраивается:',
    list: [
      'структура сайта;',
      'мета-теги;',
      'скорость загрузки;',
      'адаптация под поисковые системы (перелинковка, микроразметка, смарт-фильтры, текстовая релевантность).',
    ],
    after: 'Это позволяет привлекать клиентов из поиска — бесплатно.',
  },
  {
    title: 'Тестирование и запуск',
    text: 'Перед запуском проверяется:',
    list: ['работа сайта;', 'оформление заказов;', 'корректность данных;', 'интеграции.'],
    after: 'После этого интернет-магазин запускается и начинает работать.',
  },
];

const cmsOptions = [
  {
    title: 'Создание интернет-магазина на WordPress',
    paragraphs: ['Подходит для небольших и средних проектов.', 'Преимущества:'],
    list: ['простота управления;', 'много готовых решений;', 'быстрый запуск.'],
  },
  {
    title: 'Создание интернет-магазина на OpenCart',
    paragraphs: ['Популярная CMS для e-commerce.', 'Плюсы:'],
    list: ['высокая производительность;', 'удобный каталог;', 'гибкость настроек.'],
  },
  {
    title: 'Создание интернет-магазина на 1С-Битрикс',
    paragraphs: ['Решение для крупных проектов.', 'Позволяет:'],
    list: ['интегрировать 1С;', 'автоматизировать учет;', 'управлять большим количеством товаров.'],
  },
  {
    title: 'Индивидуальная CMS для интернет-магазина',
    paragraphs: ['Разработка с нуля.', 'Мы создаем систему под задачи бизнеса:'],
    list: ['уникальный функционал;', 'любые интеграции;', 'высокая скорость работы.'],
    after: 'Важно! У нас есть собственные шаблоны интернет-магазинов. Это позволяет:',
    afterList: [
      'сократить сроки разработки;',
      'снизить стоимость;',
      'быстрее запустить проект;',
      'легко создавать и масштабировать систему онлайн-продаж из: интернет-магазина, приложения, мини-приложения (Telegram/VK/Max) и CRM.',
    ],
  },
];

const technologies = [
  ['Frontend', 'Создается внешний вид сайта. Интерфейс должен быть удобным и быстрым.'],
  ['Backend', 'Реализуется логика:', ['обработка заказов;', 'работа с данными;', 'интеграции.']],
  ['CMS и фреймворки', 'Мы используем:', ['WordPress;', 'OpenCart;', '1С-Битрикс;', 'кастомные решения.']],
  ['Интеграции и API', 'Подключаем:', ['CRM-системы;', 'платежные сервисы;', 'доставку;', 'аналитику.']],
];

const creationSteps = [
  {
    title: 'Анализ и бриф',
    text: 'На первом этапе собирается информация:',
    list: ['цели бизнеса;', 'ниша и конкуренты;', 'структура продаж;', 'требования к функционалу.'],
    after: ['Менеджер проекта помогает сформировать задачу. Это снижает риск ошибок на старте.', 'Цель — Вам нравится и удобен Ваш проект.'],
  },
  {
    title: 'Проектирование структуры',
    text: 'Создается прототип интернет-магазина.',
    listTitle: 'Он показывает:',
    list: ['структуру страниц;', 'Seo-часть;', 'логику каталога;', 'путь пользователя;', 'размещение блоков.'],
    after: ['Прототип помогает заранее понять, как будет работать сайт.', 'Цель — клиент находит Вас в Яндекс и Google среди маркетплейсов, рекламы и конкурентов.'],
  },
  {
    title: 'Дизайн',
    text: 'Разрабатывается дизайн интернет-магазина.',
    listTitle: 'Учитывается:',
    list: ['фирменный стиль;', 'поведение пользователей;', 'требования к конверсии.'],
    after: ['Дизайн влияет на продажи. Поэтому важно сделать его не просто красивым, а понятным.', 'Цель — клиент покупает у вас, после того как нашел.'],
  },
  {
    title: 'Разработка',
    text: 'На этапе разработки создается весь функционал интернет-магазина.',
    listTitle: 'Включает:',
    list: ['каталог товаров;', 'карточку товара;', 'корзину;', 'оформление заказа;', 'личный кабинет;', 'систему управления.'],
    after: ['Мы сразу закладываем возможность масштабирования.', 'Цель — клиент легко и быстро (без багов и лишних шагов) покупает и оплачивает.'],
  },
  {
    title: 'Запуск и оптимизация',
    text: 'После разработки интернет-магазин тестируется и запускается.',
    listTitle: 'Далее:',
    list: ['подключается аналитика;', 'отслеживаются показатели;', 'выполняется оптимизация.'],
    after: ['Это позволяет улучшать результат после запуска.', 'Цель — вы легко отслеживаете, кто, когда и сколько у вас купил.'],
  },
];

const approachItems = [
  ['Agile / Scrum', 'Работа делится на этапы. Клиент видит результат на каждом шаге.'],
  ['Прозрачные этапы', 'Каждый этап согласуется. Вы понимаете, за что платите.'],
  ['Фокус на конверсии', 'Главная задача интернет-магазина — продажи, и мы, как никто это понимаем.', ['продумываем структуру;', 'усиливаем триггеры;', 'упрощаем путь пользователя.']],
];

const collaborationFormats = [
  ['Проектная разработка', ['Полный цикл: от идеи до запуска.', 'Подходит, если нужен интернет-магазин под ключ.']],
  ['Выделенная команда', ['Команда разработчиков работает как ваш отдел.', 'Подходит для долгосрочных проектов.']],
  ['Почасовая работа', ['Формат для доработок и поддержки.', 'Удобно, если интернет-магазин уже есть.']],
];

const resultItems = [
  ['Готовый интернет-магазин под ключ', 'Полностью готовый продукт, который приносит прибыль:', ['каталог;', 'корзина;', 'заказы;', 'управление.']],
  ['SEO-оптимизацию', 'Интернет-магазин готов к масштабированию продвижения.'],
  ['Удобную админ-панель', 'Вы можете:', ['добавлять товары;', 'менять цены;', 'управлять заказами.']],
  ['Масштабируемую архитектуру', 'Сайт можно развивать:', ['добавлять функции;', 'подключать сервисы;', 'расширять каталог.']],
];

const supportItems = [
  ['Техническая поддержка', 'Мы следим за стабильной работой сайта.'],
  ['SLA и гарантии', 'Фиксируем условия поддержки.'],
  ['Доработки', 'Добавляем новые функции:', ['интеграции;', 'модули;', 'сервисы.']],
  ['SEO и продвижение', 'Продвигаем интернет-магазин:', [<><SiteLink href={seoHref}>SEO</SiteLink>;</>, 'любые виды рекламы;', 'прозрачная аналитика.']],
];

const priceFactors = ['сложность сайта;', 'дизайн;', 'количество товаров;', 'интеграции (CRM, 1С, API);', 'сроки и срочность разработки.'];

const priceRows = [
  ['Базовый', '10–14 дней', 'от 170 000 ₽'],
  ['Средний', '2–3 недели', 'от 250 000 ₽'],
  ['С интеграциями', '3–5 недель', 'от 350 000 ₽'],
];

const relatedServices = [
  ['Разработка Telegram Mini App', 'https://fatalitystudio.ru/services/mini-apps/telegram/'],
  ['Разработка VK Mini App', 'https://fatalitystudio.ru/services/mini-apps/vk/'],
  ['Разработка Max Mini App', 'https://fatalitystudio.ru/services/mini-apps/max/'],
  ['Разработка приложений', 'https://fatalitystudio.ru/services/mobile/'],
];

const relatedCardTitleStyle = {
  color: 'var(--ink)',
  fontFamily: "'Space Grotesk', sans-serif",
  fontSize: '24px',
  fontWeight: 600,
  letterSpacing: '-0.025em',
  lineHeight: 1.16,
};

const reviews = [
  [
    'Евгений Л., основатель стартапа (интернет-магазин на чистом коде)',
    'Нужна была разработка интернет-магазина на чистом коде с нестандартной логикой и масштабируемой архитектурой. Команда сделала полностью индивидуальное решение: frontend и backend с нуля, гибкую систему каталога и интеграции через API. Такой подход позволил реализовать сложные функции, которых нет в готовых CMS. Сейчас интернет-магазин легко масштабируется, подключили CRM, аналитику и планируем развитие в сторону единой системы с приложением и mini app. Отличное решение для нестандартных задач.',
  ],
  [
    'Ольга М., предприниматель (интернет-магазин на конструкторе компании)',
    'Обратились за созданием интернет-магазина на собственном конструкторе студии. Нужно было быстро запустить продажи без сложной разработки. Получили готовый интернет-магазин с адаптивным дизайном, корзиной, оплатой и подключением CRM. Понравилось, что можно легко управлять товарами, менять контент и добавлять новые разделы без программистов. Также сразу сделали базовую SEO-оптимизацию и подготовили структуру под продвижение. Для старта бизнеса это оказался самый быстрый и удобный вариант.',
  ],
  [
    'Дмитрий С., владелец интернет-магазина электроники (1С-Битрикс)',
    'Заказывали создание интернет-магазина на 1С-Битрикс под ключ. Для нас было важно подключить учет товаров и автоматизировать обработку заказов. Команда реализовала полноценную разработку интернет-магазина с интеграцией 1С, CRM и платежных систем. Настроили обмен данными, каталог с фильтрами, карточки товаров и складской учет. Отдельно сделали SEO-структуру и адаптацию под рекламу. После запуска интернет-магазин начал стабильно принимать заказы, а управление стало намного проще и быстрее.',
  ],
];

const faqItems = [
  {
    question: 'Сколько стоит создание интернет-магазина?',
    blocks: [
      'Стоимость зависит от проекта.',
      'В среднем:',
      ['базовый интернет-магазин — от 170 000 ₽;', 'средний проект — от 250 000 ₽;', 'сложный — от 350 000 ₽.'],
      'Точная цена рассчитывается после анализа задачи.',
    ],
  },
  {
    question: 'Сроки создания интернет-магазина?',
    blocks: ['Срок зависит от сложности.', 'В среднем:', ['простой проект — 10–14 дней;', 'стандартный — 2–3 недели;', 'сложный — до 1–2 месяцев.']],
  },
  {
    question: 'Что нужно для старта?',
    blocks: ['Чтобы создать интернет-магазин, достаточно:', ['описать задачу;', 'указать нишу;', 'рассказать о товарах.'], 'Остальное делает команда.'],
  },
  {
    question: 'Как продвигать интернет-магазин?',
    blocks: ['Используются:', [<><SiteLink href={seoHref}>SEO-продвижение</SiteLink>;</>, 'Яндекс Директ;', 'реклама в соцсетях;', 'контент-маркетинг.']],
  },
  {
    question: 'Можно ли интегрировать интернет-магазин с CRM и автоматически обрабатывать заказы?',
    blocks: ['Да. Мы сразу внедряем CRM.', 'Это позволяет:', ['автоматически обрабатывать заявки;', 'сохранять данные клиентов;', 'управлять продажами;', 'отслеживать аналитику.']],
  },
  {
    question: 'Можно ли создать приложение на основе интернет-магазина?',
    blocks: ['Да. Интернет-магазин можно масштабировать в мобильное приложение.', 'Это увеличивает удобство для пользователей и продажи.'],
  },
  {
    question: 'Можно ли сделать Mini App (мини-приложение) на базе интернет-магазина?',
    blocks: [
      'Да. Это одно из наших ключевых преимуществ.',
      'Мы можем создать единую систему:',
      ['интернет-магазин;', 'мобильное приложение;', 'Mini App (Telegram, VK и др.);', 'CRM-система.'],
      'Все работает в одном месте.',
      'Вы получаете:',
      ['единое управление;', 'синхронизацию данных;', 'автоматизацию процессов;', 'рост продаж.'],
      'Это полноценная digital-экосистема для бизнеса.',
    ],
  },
];

const typeOptions = ['Интернет-магазин товаров', 'Интернет-магазин с каталогом и фильтрами', 'Интернет-магазин с интеграцией CRM', 'Персонализированный интернет-магазин'];

function BulletList({ items }) {
  return (
    <ul className="source-list">
      {items.map((item, index) => (
        <li key={typeof item === 'string' ? item : index}>{item}</li>
      ))}
    </ul>
  );
}

function Paragraphs({ items }) {
  return items.map((item) => <p key={item}>{item}</p>);
}

function SectionHeader({ title, description, dark = false }) {
  return (
    <div className={`sec-head${dark ? ' ink-head' : ''}`}>
      <div>
        <h2>{title}</h2>
      </div>
      {description && <p className="sub">{description}</p>}
    </div>
  );
}

function ManagerNote() {
  return (
    <div className="manager-note lead-manager-note">
      {/* TODO(brand-redesign): add the manager photo and name from the source brief. */}
      <span aria-hidden="true" />
      <p>Отвечу в течение 1 часа</p>
    </div>
  );
}

function LeadBlock({ idPrefix, formId }) {
  return (
    <div className="lead-grid">
      <div className="lead-side">
        <p className="lead-text">Оставьте заявку — менеджер свяжется с вами, уточнит детали проекта и предложит решение.</p>
        <p className="lead-text">Мы поможем:</p>
        <BulletList items={['выбрать платформу;', 'разработать интернет-магазин;', 'подключить CRM;', 'запустить продажи из разных источников.']} />
      </div>
      <div className="lead-form-stack">
        <LeadForm
          formId={formId}
          idPrefix={idPrefix}
          contactLabel="Телефон или E-mail"
          contactType="text"
          contactPlaceholder="+7 или почта"
          showTelegram={false}
          showCompany={false}
          typeLabel="Тип сайта"
          typeOptions={typeOptions}
          submitLabel="Получить расчёт бесплатно"
          taskPlaceholder="Комментарий"
        />
        <ManagerNote />
      </div>
    </div>
  );
}

function EcommerceDevelopmentPage() {
  return (
    <RedesignPage>
      <PageMeta
        title="Разработка интернет-магазина под ключ - заказать разработку продающего интернет-магазина любой сложности"
        description="Закажите профессиональную разработку интернет-магазина любой сложности под ключ. Создание интернет-магазина с товарами, каталогом, seo-оптимизацией и уникальным дизайном. Любые cms-системы (1c-Bitrix, OpenCart, WordPress), индивидуальная разработка, интеграции. Системный подход, множество кейсов и команда профессионалов. Разработали более 70 интернет-магазинов под ключ. Рассчитайте стоимость в веб-студии fatalitystudio.ru или по телефону +7 (925) 653-04-54 !"
      />
      <RedesignHeader />

      <section className="ink service-hero">
        <div
          className="glow"
          style={{ right: '-360px', top: '-340px', width: '980px', height: '980px', opacity: 0.1 }}
        />
        <div className="container service-hero-grid">
          <div>
            <h1>Создание интернет-магазина под ключ</h1>
            <p className="hero-sub">Создание интернет-магазина — это разработка полноценного сайта для онлайн-продаж, который помогает бизнесу привлекать клиентов, обрабатывать заказы и увеличивать продажи. Интернет-магазин — это не просто страница с товарами, а система, которая объединяет каталог, оплату, CRM и аналитику.</p>
            <p className="service-hero-copy">Разработка интернет-магазина под ключ включает проектирование, дизайн, программирование и запуск. В результате бизнес получает готовый инструмент для работы в интернете, который может работать стабильно и приносить прибыль.</p>
          </div>
          <div className="service-hero-panel" aria-label="Создание интернет-магазина под ключ">
            {['каталог', 'оплата', 'CRM', 'аналитика', 'SEO'].map((item, index) => (
              <div className="panel-line" key={item}>
                <span>{String(index + 1).padStart(2, '0')}</span>
                <b>{item}</b>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader
            title="Создание интернет-магазина для бизнеса"
            description="Создание интернет-магазина — это решение для компаний, которые хотят продавать товары через интернет и автоматизировать бизнес-процессы. Такой сайт позволяет работать с клиентами, управлять заказами и масштабировать продажи без увеличения затрат."
          />
          <div className="split-proof">
            <div>
              <p>Интернет-магазин подходит, если нужно:</p>
              <BulletList items={ecommerceTasks} />
            </div>
            <div>
              <p>Интернет-магазин становится центром управления бизнесом. Все процессы — от заявки до доставки — происходят в одном месте.</p>
              <p>Важно! Интернет-магазин должен быть не просто красивым. Он должен быть удобным, быстрым и понятным для пользователя. Только в этом случае сайт будет конвертировать посетителей в клиентов. А еще… он должен "нравиться" не только людям, но и поисковикам, чтобы люди вас находили, для этого — мы создаем сразу под <SiteLink href={seoHref}>SEO</SiteLink>.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader title="Какие задачи решает интернет-магазин" description="Разработка интернет-магазина решает сразу несколько задач бизнеса. Это не просто сайт, а инструмент для продаж, маркетинга и управления." />
          <div className="split-proof">
            <div>
              <p>Интернет-магазин позволяет:</p>
              <BulletList items={salesTasks} />
            </div>
            <div>
              <p>С помощью интернет-магазина можно:</p>
              <BulletList items={growthTasks} />
              <p>Интернет-магазин дает возможность бизнесу расти быстрее, чем офлайн-точка.</p>
              <SiteLink href="#ecommerce-lead-final" className="btn btn-primary section-action">
                За системой продаж — в Fatality
              </SiteLink>
            </div>
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader title="Какие интернет-магазины мы создаем" description="Мы разрабатываем интернет-магазины под разные задачи. Каждый проект создается с учетом бизнеса, ниши и целевой аудитории." />
          <div className="compact-card-grid">
            {storeTypes.map((item, index) => (
              <div className="compact-card interactive-card" key={item.title}>
                <div className="compact-num">{String(index + 1).padStart(2, '0')}</div>
                <h3>{item.title}</h3>
                <Paragraphs items={item.paragraphs} />
                {item.list && <BulletList items={item.list} />}
                {item.secondTitle && <p>{item.secondTitle}</p>}
                {item.secondList && <BulletList items={item.secondList} />}
                {item.after && <p>{item.after}</p>}
                <SiteLink href="#ecommerce-lead-final" className="link-flat">
                  Узнать стоимость
                </SiteLink>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="ink sec-pad">
        <div className="container">
          <SectionHeader dark title="Что входит в создание интернет-магазина" description="Создание интернет-магазина — это комплекс работ. Каждый этап влияет на результат." />
          <div className="process-rail process-rail-five">
            {includedSteps.map((item, index) => (
              <div className="process-step" key={item.title}>
                <div className="process-num">{String(index + 1).padStart(2, '0')}</div>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
                {item.listTitle && <p>{item.listTitle}</p>}
                <BulletList items={item.list} />
                <p>{item.after}</p>
              </div>
            ))}
          </div>
          <SiteLink href="#ecommerce-calc" className="btn btn-primary section-action">
            Начать проект
          </SiteLink>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader title="CMS для создания интернет-магазина" description="Мы создаем интернет-магазины на любой платформе. Выбор зависит от задач бизнеса." />
          <div className="compact-card-grid">
            {cmsOptions.map((item, index) => (
              <div className="compact-card" key={item.title}>
                <div className="compact-num">{String(index + 1).padStart(2, '0')}</div>
                <h3>{item.title}</h3>
                <Paragraphs items={item.paragraphs} />
                <BulletList items={item.list} />
                {item.after && <p>{item.after}</p>}
                {item.afterList && <BulletList items={item.afterList} />}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="ink sec-pad">
        <div className="container">
          <SectionHeader dark title="Технологии создания интернет-магазинов" />
          <div className="tech-tiles">
            {technologies.map(([title, text, list], index) => (
              <div className="tech-tile" key={title}>
                <div className="why-n">{String(index + 1).padStart(2, '0')}</div>
                <h3>{title}</h3>
                <p>{text}</p>
                {list && <BulletList items={list} />}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader title="Как проходит создание интернет-магазина" description="Создание интернет-магазина проходит поэтапно. Такой подход позволяет контролировать сроки, бюджет и результат проекта." />
          <div className="process-rail process-rail-five">
            {creationSteps.map((item, index) => (
              <div className="process-step" key={item.title}>
                <div className="process-num">{String(index + 1).padStart(2, '0')}</div>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
                {item.listTitle && <p>{item.listTitle}</p>}
                <BulletList items={item.list} />
                {item.after.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader title="Подход к созданию интернет-магазинов" description="Мы используем системный подход к разработке интернет-магазинов." />
          <div className="compact-card-grid">
            {approachItems.map(([title, text, list], index) => (
              <div className="compact-card" key={title}>
                <div className="compact-num">{String(index + 1).padStart(2, '0')}</div>
                <h3>{title}</h3>
                <p>{text}</p>
                {list && (
                  <>
                    <p>Мы:</p>
                    <BulletList items={list} />
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="ink sec-pad">
        <div className="container">
          <SectionHeader dark title="Форматы сотрудничества" description="Мы предлагаем несколько форматов разработки интернет-магазина." />
          <div className="compact-card-grid">
            {collaborationFormats.map(([title, paragraphs], index) => (
              <div className="compact-card interactive-card" key={title}>
                <div className="compact-num">{String(index + 1).padStart(2, '0')}</div>
                <h3>{title}</h3>
                <Paragraphs items={paragraphs} />
                <SiteLink href="#ecommerce-lead-final" className="link-flat">
                  Выбрать этот формат
                </SiteLink>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader title="Что вы получаете в итоге" description="Результат разработки — это не просто сайт." />
          <div className="compact-card-grid">
            {resultItems.map(([title, text, list], index) => (
              <div className="compact-card" key={title}>
                <div className="compact-num">{String(index + 1).padStart(2, '0')}</div>
                <h3>{title === 'SEO-оптимизацию' ? <SiteLink href={seoHref}>{title}</SiteLink> : title}</h3>
                <p>{text}</p>
                {list && <BulletList items={list} />}
              </div>
            ))}
          </div>
          <SiteLink href="#ecommerce-lead-final" className="btn btn-primary section-action">
            Заказать интернет-магазин
          </SiteLink>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader title="Поддержка и развитие интернет-магазина" description="После запуска работа не заканчивается." />
          <div className="compact-card-grid">
            {supportItems.map(([title, text, list], index) => (
              <div className="compact-card" key={title}>
                <div className="compact-num">{String(index + 1).padStart(2, '0')}</div>
                <h3>{title}</h3>
                <p>{text}</p>
                {list && <BulletList items={list} />}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top" id="ecommerce-calc">
        <div className="container">
          <SectionHeader title="Стоимость создания интернет-магазина" description="Стоимость разработки интернет-магазина зависит от задач проекта." />
          <div className="pricing-layout">
            <div className="price-list">
              <h3 className="pricing-subhead">От чего зависит цена</h3>
              <BulletList items={priceFactors} />
              <h3 className="pricing-subhead">Примерные цены</h3>
              <div className="price-table-scroll">
                <table className="tz-price-table">
                  <thead>
                    <tr>
                      <th>Тип интернет-магазина</th>
                      <th>Срок</th>
                      <th>Стоимость</th>
                    </tr>
                  </thead>
                  <tbody>
                    {priceRows.map(([type, time, price]) => (
                      <tr key={type}>
                        <td>{type}</td>
                        <td>{time}</td>
                        <td>{price}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {priceRows.map(([type, time, price]) => (
                <p className="section-note" key={`${type}-note`}>{type} | {time} | {price}</p>
              ))}
            </div>
            <div className="price-note">
              <h3>Как рассчитывается стоимость</h3>
              <p>Смета формируется по этапам:</p>
              <BulletList items={['проектирование;', 'дизайн;', 'SEO;', 'разработка;', 'интеграции.']} />
              <h3>Получить расчет</h3>
              <p>Есть идея или проект? Оставьте заявку — рассчитаем стоимость и предложим решение.</p>
              <LeadForm
                formId="ecommerce-calc-form"
                idPrefix="ecommerce-calc"
                contactLabel="Телефон или E-mail"
                contactType="text"
                contactPlaceholder="+7 или почта"
                showTelegram={false}
                showCompany={false}
                typeLabel="Тип сайта"
                typeOptions={typeOptions}
                submitLabel="Получить расчёт бесплатно"
                taskPlaceholder="Комментарий"
              />
              <ManagerNote />
            </div>
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader title="Похожие услуги" />
          <div className="related-grid">
            {relatedServices.map(([title, href]) => (
              <SiteLink href={href} className="related-card" key={title}>
                <div style={relatedCardTitleStyle}>{title}</div>
                <span>↗</span>
              </SiteLink>
            ))}
          </div>
        </div>
      </section>

      <CommerceEcosystem />

      <section className="ink sec-pad">
        <div className="container">
          <SectionHeader dark title="Кейсы создания интернет-магазинов" />
          <h3 className="standalone-h3 ink-standalone">Примеры с результатами</h3>
          <SiteLink href="https://fatalitystudio.ru/portfolio/tech-store/" className="case-teaser section-action case-teaser-telstore">
            <TelStoreCover preview wide alt="" />
            <div className="case-teaser-body">
              <div className="case-card-title">Создание интернет-магазина техники в Москве</div>
              <p>Разработка интернет-магазина техники под ключ для рынка Москва. Проект включал полный цикл: от создания сайта с нуля до SEO-продвижения и запуска рекламы.</p>
              <span className="link-flat">открыть кейс</span>
            </div>
          </SiteLink>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader title="Отзывы клиентов: от идеи до готового интернет-магазина" />
          <ReviewsCarousel className="reviews-grid reviews-grid-three">
            {reviews.map(([name, text]) => (
              <figure className="review-card" aria-label={name} key={name}>
                <blockquote>{text}</blockquote>
                <ReviewAuthor label={name} />
              </figure>
            ))}
          </ReviewsCarousel>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <div className="faq-grid">
            <div>
              <h2 className="standalone-h2">Ответы на частые вопросы</h2>
            </div>
            <div className="faq-list">
              {faqItems.map((item) => (
                <AccessibleFaqItem key={item.question} question={item.question}>
                      {item.blocks.map((block, index) => (
                        Array.isArray(block) ? <BulletList items={block} key={`list-${index}`} /> : <p key={typeof block === 'string' ? block : index}>{block}</p>
                      ))}
                </AccessibleFaqItem>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="ink lead" id="ecommerce-lead-final">
        <div
          className="glow"
          style={{ left: '-300px', top: '-200px', width: '700px', height: '700px', opacity: 0.1 }}
        />
        <div className="container" style={{ position: 'relative' }}>
          <h2 className="lead-heading">Заказать создание интернет-магазина</h2>
          <LeadBlock idPrefix="ecommerce-final" formId="ecommerce-lead-form" />
        </div>
      </section>

      <RedesignFooter />
    </RedesignPage>
  );
}

export default EcommerceDevelopmentPage;
